<div class="form-group">
    <div class="form-row form-row--input form-row--right-align form-row--vertically-centered">
        <div class="form-row__controls form-row__control-column form-row__control-column--fixed">
            <label>{{ _translateCustomized(".Filters_label") }}</label>
        </div>
        @for (group of _groupConfigs; track group) {
            <div
                class="form-row__controls form-row__control-column form-row__control-column--fixed"
            >
                <lg-multi-filter
                    [placeholder]="group.filterPlaceholder"
                    [source]="group.filterSource"
                    [(filter)]="group.filter"
                    [focusEnabled]="true"
                    (filterChange)="_refilter()"
                ></lg-multi-filter>
            </div>
        }
    </div>

    <div class="form-row form-row--multilevel-picker">
        <div class="form-row__controls form-row__controls--3col flexcol">
            @for (group of _groupConfigs; track group) {
                <div
                    class="lg-multilevel-picker__collapse"
                    [class.lg-multilevel-picker__collapse--collapsed]="group.collapsed"
                    (click)="_collapseGroup(group)"
                >
                    {{ group.label
                    }}<lg-icon
                        icon="icon-arrow-down"
                        class="lg-multilevel-picker__collapse-icon"
                    ></lg-icon>
                </div>
                <lg-item-selector
                    [hidden]="group.collapsed"
                    class="flex-flexible"
                    [source]="group.list"
                    [disabled]="_readonly"
                    [selection]="group.selection"
                    [config]="group.selectorConfiguration"
                >
                    <ng-template let-item>
                        @if (item.blockedItemsCount) {
                            <lg-icon
                                [icon]="_alreadyUsedIcon"
                                lgSimpleTooltip="={{
                                    item.blockedWholeGroup ? group.isUsed : group.isPartiallyUsed
                                }}"
                                [tooltipOptions]="{ delayShow: 0, delayHide: 0 }"
                            ></lg-icon>
                        }
                        <div
                            class="lg-pivot-table-filterable"
                            [class.lg-pivot-table-filterable--active]="group.filter[item.groupCode]"
                            (click)="_groupFilterToggle($event, group, item)"
                        >
                            <lg-hoverable-icon
                                [icon]="
                                    group.filter[item.groupCode]
                                        ? 'icon-filter'
                                        : 'icon-filter-empty'
                                "
                                [hoverIcon]="
                                    group.filter[item.groupCode]
                                        ? 'icon-filter-empty'
                                        : 'icon-filter'
                                "
                            ></lg-hoverable-icon>
                        </div>
                    </ng-template>
                </lg-item-selector>
            }
        </div>
        <div class="form-row__controls form-row__controls--3col flexcol">
            <div class="lg-multilevel-picker__collapse-like">
                {{ _translateCustomized(".Items_select_label") }}
                @if (_allowCopyPaste) {
                    <lg-copy-button
                        [columnsDefinitions]="_copyPasteColumns"
                        [onGetData]="_getAllValues"
                        notificationPosition="top-left"
                    ></lg-copy-button>
                    @if (!_readonly) {
                        <lg-paste-button
                            [columnsDefinitions]="_copyPasteColumns"
                            [onGetData]="_getAllValues"
                            [onPutData]="_setAllValues"
                            [preprocessData]="_preprocessAllValues"
                            [unmatched]="'allow'"
                            [extraInformation]="_copyPasteExtra"
                        ></lg-paste-button>
                    }
                }
            </div>
            <lg-item-selector
                class="flex-flexible"
                [source]="_availableItemsList"
                [disabled]="_readonly"
                [(selection)]="_itemSelection"
                [config]="_itemSelectorConfig"
            >
                <ng-template let-item>
                    @if (item.assignedTo) {
                        <lg-icon
                            icon="icon-info"
                            [lgSimpleTooltip]="_itemAllocatedTooltip(item)"
                            [tooltipOptions]="{ delayShow: 0, delayHide: 0 }"
                        ></lg-icon>
                    }
                </ng-template>
            </lg-item-selector>
        </div>
    </div>
</div>

<div class="form-group form-group--buttons">
    @if (!_readonly) {
        <div class="form-row">
            <div class="form-row__button-info">
                <lg-quick-notification [message]="_notification"></lg-quick-notification>
            </div>
            <lg-button
                (click)="_save()"
                buttonClass="button--primary"
                textLc=".Save_button"
                [isDisabled]="!_modified"
            ></lg-button>
            <lg-button (click)="_cancel()" textLc=".Cancel_button"></lg-button>
        </div>
    }
    @if (_readonly) {
        <div class="form-row">
            <lg-button (click)="_cancel()" textLc=".Close_button"></lg-button>
        </div>
    }
</div>
